import React__default, { useState, useEffect } from 'react';
import { useLayoutEffect } from './use-layout-effect.mjs';

let isHydrated = false;
let id = 0;
function getId() {
  return ++id;
}
const useReactId = React__default["useId".toString()];
function useIncrementalId() {
  const [id2, setId] = useState(isHydrated ? getId : null);
  useLayoutEffect(() => {
    if (id2 === null) {
      setId(getId());
    }
  }, [id2]);
  useEffect(() => {
    if (!isHydrated) {
      isHydrated = true;
    }
  }, []);
  return String(id2) ?? void 0;
}
const useId = useReactId ?? useIncrementalId;

export { useId };
//# sourceMappingURL=use-id.mjs.map
